// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"_39uz4"};